import * as React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChatPane from "./chatPane";

type ChatChannelClient = "PROVIDER" | "REFERRER";

export default function ChatDialog({
  open,
  onClose,
  leadId,
  audience,        // "PROVIDER" or "REFERRER"
  title,
  viewerRole = "AGENT",
  height = 520,
}: {
  open: boolean;
  onClose: () => void;
  leadId: string | number | null;
  audience: ChatChannelClient;
  title?: string;
  viewerRole?: "AGENT" | "PROVIDER" | "REFERRER";
  height?: number | string;
}) {
  if (!leadId) return null;

  const computedTitle =
    title ??
    (audience === "PROVIDER" ? "Conversation — Provider" : "Conversation — Referrer");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        {computedTitle}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <ChatPane
          leadId={String(leadId)}
          audience={audience}
          viewerRole={viewerRole}
          height={height}
          pollMs={4000}
          // disableSubscription // uncomment if WS not wired
        />
      </DialogContent>
    </Dialog>
  );
}
